/**
 * @flow
 */
import {EgretLoadable} from "../../../egret";
import {ROUTE} from '../../settings';

const settingsRoutes = [
  {path: ROUTE.SETTINGS_COMPANY, component: EgretLoadable({loader: () => import("./SettingsCompany")})},
  {path: ROUTE.SETTINGS_BRANCH, component: EgretLoadable({loader: () => import("./SettingsBranch")})},
  {path: ROUTE.SETTINGS_GROUP, component: EgretLoadable({loader: () => import("./SettingsGroup")})},
  {path: ROUTE.SETTINGS_DEVICE, component: EgretLoadable({loader: () => import("./SettingsDevice")})},
  {path: ROUTE.SETTINGS_USER, component: EgretLoadable({loader: () => import("./SettingsUser")})},
  {path: ROUTE.SETTINGS_DEVICE_TYPE, component: EgretLoadable({loader: () => import("./SettingsDeviceType")})},
  {path: ROUTE.SETTINGS_PROFILE, component: EgretLoadable({loader: () => import("./SettingsProfile")})},
  {path: ROUTE.SETTINGS_CONNECT, component: EgretLoadable({loader: () => import("./SettingsConnect")})},
];

export default settingsRoutes;
